import React, { useState } from 'react'
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import styled, { css } from 'styled-components';
import CKEditor from 'ckeditor4-react';
import api from '../../../services/client';
import { merge } from 'lodash';
import { ToastContainer, toast } from 'react-toastify';
import { useHistory, Redirect } from 'react-router-dom';
import routes from '../../routes';
import { useAuth } from '../../../auth/AuthContext';

//import './jobpost.css'

const JPContainer = styled(Container)`
    width: 45%;
    border-radius: 15px;
    border: 1px solid #f0f0f0;
    border-top: 4px solid #0A3BB4;
    margin-bottom: 5%;
`;

const JPForm = styled(Form)`
    margin: 0 8%;
    
    ${props =>
        props.index === '1' &&
        css`
            margin-top: 10%;
    `};

    & .form-label{
        font-size: 14px;
    }

    & input,select,textarea {
        background: #f9f9f9;
    }
`;

const FormTitle = styled(Form.Label)`
    font-weight: bold;
`;


const Title = styled.div`
    align-items: center;
    justify-content: center;
    display: flex;
    text-align: center;
    margin: auto;
    padding-bottom: 20px;
    font-size: 40px;
    font-weight:500;
`;


function PostJobs(props) {

    const history = useHistory();
    const { currentUser } = useAuth();

    const [ckEditorValue, setCkEditorValue] = useState([])

    const onEditorChange = e => {
        const value ={};
        value[e.editor.name] = e.editor.getData();
        setCkEditorValue(merge(ckEditorValue, value));
    }

    const handleOnSubmit = async e => {
        e.preventDefault();
        var formData = new FormData(e.target),
        formDataObj = Object.fromEntries(formData.entries())
        formDataObj.CompanyId = currentUser.Company.CompanyId;
        formDataObj.IsFeatured = formDataObj.IsFeatured ?? 0;
        // const response = await api.login(formDataObj);
        // setValue('authtoken',response.data.token);

        const data = await api.postJobDetails(merge(formDataObj, ckEditorValue)).then((data) => {
            toast("Job Posted successfully");
            history.push(routes.JOBS);
         })
        .catch(error => {
            toast("Unable Post Your Job");
            return error;
        });
    
       // console.log(merge(formDataObj, ckEditorValue));
    }

    return (<Redirect to={routes.JOBS} />);
    return (currentUser && currentUser.Company) ? (
        <>
        <Title> Post A Job </Title>      
        
        <JPForm onSubmit={handleOnSubmit}>
            <JPContainer>
            <Form.Control type="hidden" name="CompanyId" value={currentUser?.Company?.CompanyId} />
                <Form.Group className="mb-4" controlId="formEmail" style={{marginTop: '10%'}}>
                    <FormTitle>Your Email address</FormTitle>
                    <Form.Control type="email" name="Email" placeholder="name@example.com" readOnly />
                </Form.Group>

                <Form.Group className="mb-4" controlId="formJobTitle">
                    <FormTitle>Job Title</FormTitle>
                    <Form.Control type="text" name="Title" placeholder="Title" />
                </Form.Group>

                <Form.Group className="mb-4" controlId="formLocation">
                    <FormTitle>Location</FormTitle> (optional)
                    <Form.Control type="text" name="Location" placeholder='eg:"London"' />
                    <Form.Text id="locationHelpBlock" muted>Leave this blank if the location is not important</Form.Text>
                </Form.Group>

                <Form.Group className="mb-4" controlId="formRegion">
                    <FormTitle>Job Region</FormTitle>
                    <Form.Control type="text" name="Region" placeholder='eg:"Camden"' />
                </Form.Group>

                <Form.Group className="mb-4" controlId="formJobType">
                    <FormTitle>Job Type</FormTitle>
                    <Form.Control as="select" name='Type' placeholder='Choose a type'>
                        <option>Full Time</option>
                        <option>Part Time</option>
                    </Form.Control>
                </Form.Group>

                <Form.Group className="mb-4" controlId="formJobCatogery">
                    <FormTitle>Job Catogery</FormTitle>
                    <Form.Control as="select" name='Category' placeholder='Choose a catogery'>
                        <option value='Cloud'>Cloud Computing</option>
                        <option value='Security'>Cyber Security</option>
                        <option value='DataAnalytics'>Data Analytics</option>
                        <option value='ITHelpDesk'>IT Help Desk</option>
                    </Form.Control>
                </Form.Group>

                <Form.Group className="mb-4" controlId="formOverView">
                    <FormTitle>Overview</FormTitle>
                        <CKEditor onChange={onEditorChange} name='Description' />
                    {/* <Form.Control as={CKEditor} rows={3} name='Description'/>  */}
                </Form.Group>

                <Form.Group className="mb-4" controlId="formDecription">
                    <FormTitle>What you'll be doing</FormTitle>
                        <CKEditor onChange={onEditorChange} name='Objective'/>
                    {/* <Form.Control as="textarea" rows={3} name='Description'/> */}
                </Form.Group>

                <Form.Group className="mb-4" controlId="formOffer">
                    <FormTitle>What we offer</FormTitle>
                        <CKEditor  onChange={onEditorChange} name='Offers' />
                    {/* <Form.Control as="textarea" rows={3} name='Description'/> */}
                </Form.Group>

                <Form.Group className="mb-4" controlId="formWhoApply">
                    <FormTitle>Who should apply?</FormTitle>
                        <CKEditor  onChange={onEditorChange} name='WhoShouldApply'/>
                    {/* <Form.Control as="textarea" rows={3} name='Description'/> */}
                </Form.Group>

                <Form.Group className="mb-4" controlId="formNext">
                    <FormTitle>What Next?</FormTitle>
                        <CKEditor onChange={onEditorChange} name='WhatNext'/>
                    {/* <Form.Control as="textarea" rows={3} name='Description'/> */}
                </Form.Group>

                <Form.Group className="mb-4" controlId="formApplicationEmail">
                    <FormTitle>Application Email/ URL</FormTitle>
                    <Form.Control type="text" name="FullLink" placeholder="Email/Url" />
                </Form.Group>

                <Row>
                    <Col md='5'>
                        <Form.Group className="mb-4" controlId="formClosingDate">
                            <FormTitle>Closing Date</FormTitle> (Optional)
                            <Form.Control type="date" name="ClosingDate" placeholder="Username or Email Address" />
                            <Form.Text id="closingDateHelpBlock" muted>Deadline for new applicants.</Form.Text>
                        </Form.Group>
                    </Col>
                    <Col md='7'>
                        <Form.Group className="mb-4" controlId="fromFeaturedJob">
                        <Form.Check
                            type="checkbox"
                            name="IsFeatured"
                            label={` Do you want this to be a Featured Job?`}
                            value={1}
                            style={{
                                marginTop: '10%'
                            }}
                        />
                        </Form.Group>
                    </Col>
                </Row>
                
                <Row>
                    <Button type="submit" style={{height: '50px', backgroundColor:'#0A3BB4', borderRadius:'0px 0px 2px 2px'}}>
                        Submit {'>'}
                    </Button>
                </Row>
            </JPContainer>
        </JPForm>
        <ToastContainer position="bottom-right" autoClose={2000} closeOnClick />
           
        </> 
    ) : (<Redirect to={routes.JOBS} />)
}

PostJobs.propTypes = {

}

export default PostJobs

